import { BaseEntity } from 'src/app/entity/base-entity';
import { Time } from '@angular/common';

export class LicenceTableDto extends BaseEntity {
  name: string;
  to: Date;
  userCount: number;
  manufacturerCount: number;
  hololensId: string;
  customerId: number;
}
